"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConnectionHealthData = /*#__PURE__*/function () {
  function ConnectionHealthData() {
    _classCallCheck(this, ConnectionHealthData);

    this.connectionStartTimestampMs = 0;
    this.consecutiveStatsWithNoPackets = 0;
    this.lastPacketLossInboundTimestampMs = 0;
    this.lastGoodSignalTimestampMs = 0;
    this.lastWeakSignalTimestampMs = 0;
    this.lastNoSignalTimestampMs = 0;
    this.consecutiveMissedPongs = 0;
    this.packetsReceivedInLastMinute = [];
    this.fractionPacketsLostInboundInLastMinute = [];
    this.audioSpeakerDelayMs = 0;
    this.connectionStartTimestampMs = Date.now();
    this.lastGoodSignalTimestampMs = Date.now();
  }

  _createClass(ConnectionHealthData, [{
    key: "setConnectionStartTime",
    value: function setConnectionStartTime() {
      this.connectionStartTimestampMs = Date.now();
      this.lastGoodSignalTimestampMs = Date.now();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.connectionStartTimestampMs = 0;
      this.consecutiveStatsWithNoPackets = 0;
      this.lastPacketLossInboundTimestampMs = 0;
      this.lastGoodSignalTimestampMs = 0;
      this.lastWeakSignalTimestampMs = 0;
      this.lastNoSignalTimestampMs = 0;
      this.consecutiveMissedPongs = 0;
      this.packetsReceivedInLastMinute = [];
      this.fractionPacketsLostInboundInLastMinute = [];
      this.audioSpeakerDelayMs = 0;
      this.connectionStartTimestampMs = Date.now();
      this.lastGoodSignalTimestampMs = Date.now();
    }
  }, {
    key: "isConnectionStartRecent",
    value: function isConnectionStartRecent(recentDurationMs) {
      return ConnectionHealthData.isTimestampRecent(this.connectionStartTimestampMs, recentDurationMs);
    }
  }, {
    key: "isLastPacketLossRecent",
    value: function isLastPacketLossRecent(recentDurationMs) {
      return ConnectionHealthData.isTimestampRecent(this.lastPacketLossInboundTimestampMs, recentDurationMs);
    }
  }, {
    key: "isGoodSignalRecent",
    value: function isGoodSignalRecent(recentDurationMs) {
      return ConnectionHealthData.isTimestampRecent(this.lastGoodSignalTimestampMs, recentDurationMs);
    }
  }, {
    key: "isWeakSignalRecent",
    value: function isWeakSignalRecent(recentDurationMs) {
      return ConnectionHealthData.isTimestampRecent(this.lastWeakSignalTimestampMs, recentDurationMs);
    }
  }, {
    key: "isNoSignalRecent",
    value: function isNoSignalRecent(recentDurationMs) {
      return ConnectionHealthData.isTimestampRecent(this.lastNoSignalTimestampMs, recentDurationMs);
    }
  }, {
    key: "clone",
    value: function clone() {
      var cloned = new ConnectionHealthData();
      cloned.connectionStartTimestampMs = this.connectionStartTimestampMs;
      cloned.consecutiveStatsWithNoPackets = this.consecutiveStatsWithNoPackets;
      cloned.lastPacketLossInboundTimestampMs = this.lastPacketLossInboundTimestampMs;
      cloned.lastGoodSignalTimestampMs = this.lastGoodSignalTimestampMs;
      cloned.lastWeakSignalTimestampMs = this.lastWeakSignalTimestampMs;
      cloned.lastNoSignalTimestampMs = this.lastNoSignalTimestampMs;
      cloned.consecutiveMissedPongs = this.consecutiveMissedPongs;
      cloned.packetsReceivedInLastMinute = this.packetsReceivedInLastMinute.slice(0);
      cloned.fractionPacketsLostInboundInLastMinute = this.fractionPacketsLostInboundInLastMinute.slice(0);
      cloned.audioSpeakerDelayMs = this.audioSpeakerDelayMs;
      return cloned;
    }
  }, {
    key: "setConsecutiveMissedPongs",
    value: function setConsecutiveMissedPongs(pongs) {
      this.consecutiveMissedPongs = pongs;
    }
  }, {
    key: "setConsecutiveStatsWithNoPackets",
    value: function setConsecutiveStatsWithNoPackets(stats) {
      this.consecutiveStatsWithNoPackets = stats;
    }
  }, {
    key: "setLastPacketLossInboundTimestampMs",
    value: function setLastPacketLossInboundTimestampMs(timeStamp) {
      this.lastPacketLossInboundTimestampMs = timeStamp;
    }
  }, {
    key: "setLastNoSignalTimestampMs",
    value: function setLastNoSignalTimestampMs(timeStamp) {
      this.lastNoSignalTimestampMs = timeStamp;
    }
  }, {
    key: "setLastWeakSignalTimestampMs",
    value: function setLastWeakSignalTimestampMs(timeStamp) {
      this.lastWeakSignalTimestampMs = timeStamp;
    }
  }, {
    key: "setLastGoodSignalTimestampMs",
    value: function setLastGoodSignalTimestampMs(timeStamp) {
      this.lastGoodSignalTimestampMs = timeStamp;
    }
  }, {
    key: "setAudioSpeakerDelayMs",
    value: function setAudioSpeakerDelayMs(delayMs) {
      this.audioSpeakerDelayMs = delayMs;
    }
  }], [{
    key: "isTimestampRecent",
    value: function isTimestampRecent(timestampMs, recentDurationMs) {
      return Date.now() < timestampMs + recentDurationMs;
    }
  }]);

  return ConnectionHealthData;
}();

exports.default = ConnectionHealthData;